/* eslint-disable max-len */
import {
  Box,
  CircularProgress,
  Dialog as MuiDialog,
  DialogContent,
  Grid,
  styled,
  useMediaQuery,
  Modal,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import ApiRoutes from "../../../config/api.routes";
import { AppRoutes } from "../../../config";
import { useAxios } from "../../../services/http.service";
import useMetaMask from "../../../contexts/useMetaMask";
import { relayContractCall, isUserRejection } from "../../../services/relay.service";
import { getReadOnlyContract } from "../../../services/contract.service";
import { ScanMain } from "../components";
import InfoIconOutlined from "@mui/icons-material/InfoOutlined";
import AnnouncementOutlined from "@mui/icons-material/Announcement";

// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import { VerifiedUser, SmsFailed as Flag } from "@mui/icons-material";
import moment from "moment";
import { ActionBtn, AddressLink, TableComponent, Text } from "../../../components";
import OrgPopUp from "../../../components/OrgPopUp";
import { sixDigits, sizing, toReadable } from "../../../utils/methods";
import {
  ClickableContainer,
  EcoBankAssetsSchema,
  EcoBankLandsSchema,
  MobileEcoBankLandsSchema,
  TransactionMobileSchema,
  TransactionsSchema,
  TrusteeLandsSchema,
} from "../../../utils/table-schemas";
import {
  GlobalTrustAdminIcon,
  GuardianIcon,
  PatronIcon,
  PioneerIcon,
  TrustAdminIcon,
  TrusteeIcon,
} from "../../../components/RoleIcons";
import {
  // TrusteeIcon2,
  Widget,
  WidgetContainer,
  WidgetRow,
  UserWidget,
  MainWidgetContainer,
} from "../../Profile/Dashboard";
import { TabsRow } from "../TrustWallet";

import { ButtonHeight } from "../../../utils/constants";
import ProfilePicture from "../../Profile/verification/profile-picture";
import useAuthorization from "../../../contexts/useAuthorization";
import { Wrapper } from "../../Scan";
import { CircularIcon, IconContainer, InfoBody, Row, getTrusteeSchema } from "../../Profile/Portal";
import { FilterBlock } from "../../Profile/GuardianPortal";
import { fromWei } from "web3-utils";
import { formatValue } from "../../../utils/formatValue";
import { isGTA } from "../../../services/challenge.service";

// type WalletInfoResponse = {
//   role: any;
//   organization: any;
//   boughtLands: number;
//   boughtLandsValue: number;
//   soldLands: number;
//   guardingTokens: number;
//   createdAt: string;
//   name: string;
//   verified: boolean;
//   transactions: number;
//   portfolio: any;
//   trusteeVerifications: any;
//   adminVerifiedTrusts: any;
// };

const UserWallet = () => {
  const axios = useAxios();
  const { address } = useParams();
  const { library } = useMetaMask();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(560));
  const [orgModalOpen, setOrgModalOpen] = useState(false);
  const [latestLandImage, setLatestLandImage] = useState("");
  const [adminVerifiedTrusts, setAdminVerifiedTrusts] = useState<any[]>([]);

  const { isTrust, user } = useAuthorization();

  const [transactions, setTransactions] = useState(0);
  const [landsBought, setLandsBought] = useState(0);
  const [portfolioValue, setPortfolioValue] = useState(0);
  const [landsScanned, setLandsScanned] = useState(0);

  const [headerLoading, setHeaderLoading] = useState(true);
  const [statsLoading, setStatsLoading] = useState(true);
  const [balanceLoading, setBalanceLoading] = useState(true);

  const [treeBalance, setTreeBalance] = useState<any>(0);
  const [joinedDate, setJoinedDate] = useState<string>("");

  const [role, setRole] = useState<string>("");
  // Governance.isGTA(address) for an admin wallet — null until read or if the read failed. Same
  // rule as useAuthorization's isGlobalTrustAdmin: the GTA registry wins, and the "admin with no
  // country code" heuristic (the one the public-wallet endpoint itself uses) covers the gap.
  const [chainIsGTA, setChainIsGTA] = useState<boolean | null>(null);
  const [orgData, setOrgData] = useState<any>(null);
  const [orgLands, setOrgLands] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<"lands" | "transactions" | "portfolio">("transactions");
  const [profileData, setProfileData] = useState<any>(null);
  const isGlobalAdmin = role === "admin" && (chainIsGTA ?? !profileData?.countryCode);
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState<string>("");
  const [flagModalOpen, setFlagModalOpen] = useState(false);
  const [flagTrustSuccess, setFlagTrustSuccess] = useState(false);
  const [flagReasonPopupOpen, setFlagReasonPopupOpen] = useState(false);
  const [flagReason, setFlagReason] = useState("");
  // V10.1 flag standing, from chain. Two registers, deliberately both shown:
  //   Admin.flagCountOf        peer flags (flagVerifierForDismissal) plus adjudication findings
  //                            relayed via recordAdjudication — the counter dismissVerifier checks
  //                            against the (settable) threshold.
  //   EcoChallenge.flagsInWindow  panel findings against this party in the rolling 24-month window;
  //                            FLAGS_TO_DISMISS (3) in the window meets the bar (isFlaggedOut).
  // The REST count (the unified endpoint's `trustDismissal.flagsCount`, the same DB counter as
  // GET /trust-dismissal/getFlagsCount) is deliberately NOT read: at backend HEAD it is fed by
  // Admin's VerifierFlagged only, so a panel finding does not bump it until the third one reports
  // to Admin (docs/v10/BACKEND_V10_1_BRANCH_AUDIT.md, item 6). It is a lower bound — "at least N",
  // never "exactly N" — and a lower bound cannot prove the bar is met, so it must not gate the
  // action. The hard-coded "3" this page used to gate on is gone: the bar is whatever the
  // contracts say it is, and only the chain may close the action.
  const [chainFlags, setChainFlags] = useState<{
    adminCount: number;
    adjudicationCount: number;
    flagsToDismiss: number;
    flaggedOut: boolean;
  } | null>(null);
  const [flagLoading, setFlagLoading] = useState(false);
  const [flagErrorMessage, setFlagErrorMessage] = useState<string>("");
  // Flagging is pointless once the dismissal bar is met — the contract's bar, from chain. With no
  // chain read nothing can prove the bar is met (see above), so the action stays enabled rather
  // than being gated on the REST count; the contract is the final arbiter and rejects a flag past
  // the bar itself. `flagsToDismiss` keeps its 3 default for the copy only.
  const flagsToDismiss = chainFlags?.flagsToDismiss ?? 3;
  const atDismissalBar = chainFlags ? chainFlags.flaggedOut || chainFlags.adminCount >= flagsToDismiss : false;
  const [verifiedByData, setVerifiedByData] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedMenuId, setSelectedMenuId] = useState<string | null>(null);

  const navigator = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, data: any) => {
    setSelectedMenuId(data.id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setSelectedMenuId(null);
    setAnchorEl(null);
  };

  const handleOrgClick = (e: React.MouseEvent<HTMLElement>, data: any) => {
    e.stopPropagation();
    const org = data?.organization;
    if (!org) return;
    setOrgData(org);

    // Resolve the lands OrgPopUp's hero card needs. `organization.verifiedLands`
    // entries are thin (only `name`/`image`/`meta`/`ecoScore` — no `content`/`etNft`),
    // while the rich land objects (with `content` + `etNft`) live in each secondary
    // wallet's `portfolio.claimedLands`. Build a lookup of the rich objects and use
    // them to enrich the verified lands so the hero card renders fully.
    const richLands: any[] = [
      ...(Array.isArray(org?.secondaryWallets)
        ? org.secondaryWallets.flatMap((w: any) =>
            Array.isArray(w?.portfolio?.claimedLands) ? w.portfolio.claimedLands : []
          )
        : []),
      ...(Array.isArray(data?.portfolio?.claimedLands) ? data.portfolio.claimedLands : []),
    ];
    const richById = new Map<any, any>(richLands.map((l: any) => [l?.id, l]));

    const verifiedLands = Array.isArray(org?.verifiedLands) ? org.verifiedLands : [];
    const enrichedVerified = verifiedLands.map((vl: any) => richById.get(vl?.id) ?? vl);

    const orgLandsResolved = enrichedVerified.length > 0 ? enrichedVerified : richLands.length > 0 ? richLands : null;
    setOrgLands(orgLandsResolved);
    setOrgModalOpen(true);
  };

  const handleModalOpen = () => {
    navigator(AppRoutes.Profile.subRoutes.AdminPortal.path);
  };

  const blockTrustee = () => {
    navigator(AppRoutes.Profile.subRoutes.AdminPortal.path);
  };

  const noop = () => {};

  const trusteeSchema = getTrusteeSchema({
    isSmallScreen: isMobile,
    isLoading: statsLoading,
    anchorEl,
    selectedMenuId,
    navigator,
    handleOrgClick,
    handleClick,
    handleClose,
    handleModalOpen,
    blockTrustee,
    setApproveOpen: noop,
  });

  useEffect(() => {
    setChainIsGTA(null);
    if (role !== "admin" || !address) {
      return;
    }
    let cancelled = false;
    isGTA(address)
      .then((v) => {
        if (!cancelled) {
          setChainIsGTA(v);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [role, address]);

  useEffect(() => {
    if (role !== "admin" || !address) {
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(ApiRoutes.admin.verifiedBy(address));
        const data = res?.data;
        const normalized = Array.isArray(data) ? data : data?.items || data?.data || [];
        if (!cancelled) {
          setVerifiedByData(normalized);

          const trusteeLands = normalized.flatMap((trustee: any) => {
            const claimed = trustee?.portfolio?.claimedLands ?? [];
            const minted = trustee?.portfolio?.mintedLands ?? trustee?.ecoTokens?.mintedBy ?? [];
            return [...claimed, ...minted];
          });
          if (trusteeLands.length > 0) {
            const sorted = trusteeLands.sort((a: any, b: any) => (b?.ecoScore || 0) - (a?.ecoScore || 0));
            const img = sorted[0]?.content ?? sorted[0]?.image ?? "";
            if (img) setLatestLandImage(img);
          }
        }
      } catch (err) {
        console.log("error fetching verifiedBy", { err });
        if (!cancelled) {
          setVerifiedByData([]);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [role, address]);

  useEffect(() => {
    switch (true) {
      case role === "trust" && landsScanned === 0:
        setActiveTab("transactions");
        break;
      case role === "trust":
        setActiveTab("transactions");
        break;
      case landsBought > 0:
        setActiveTab("transactions");
        break;
      case landsScanned > 0:
        setActiveTab("transactions");
        break;
      default:
        setActiveTab("transactions");
        break;
    }
  }, [role, landsBought, landsScanned]);

  // Rest of the component code stays the same
  useEffect(() => {
    setTransactions(0);
    setLandsBought(0);
    setPortfolioValue(0);
    setLandsScanned(0);
    setOrgData(null);
    setOrgLands(null);
    setProfileData(null);
    setRole("");
    setTreeBalance(0);
    setBalanceLoading(true);
    setAdminVerifiedTrusts([]);
    setVerifiedByData([]);
    fetchTransactions();
    // fetchBalance();
  }, [address, library]);

  // const fetchBalance = async () => {
  //   try {
  //     const signer = await getMetaMaskSigner();
  //     const treeContract = getContract("tree-token", signer);
  //     if (treeContract) {
  //       if (!balanceLoading) {
  //         setBalanceLoading(true);
  //       }
  //       const weiBalance = await treeContract.balanceOf(address);
  //       setTreeBalance(toReadable(weiBalance));
  //     } else {
  //       setTreeBalance(0);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching tree balance:", error);
  //     setTreeBalance(0);
  //   } finally {
  //     if (balanceLoading) {
  //       setBalanceLoading(false);
  //     }
  //   }
  // };

  const fetchTransactions = async () => {
    try {
      setHeaderLoading(true);
      setStatsLoading(true);

      // Fetch unified wallet data using new consolidated endpoint
      const response = await axios.get(ApiRoutes.user.checkWallet(address as string)).then((res) => res.data);
      console.log("unified wallet response", { response });

      const source = response || {};
      const wallet = source?.wallet ?? source?.data?.wallet ?? null;
      const walletDetails = source?.walletDetails ?? source?.details ?? {};
      const ecoTokens = source?.ecoTokens ?? {};

      const toArray = (value: any) => (Array.isArray(value) ? value : []);
      const toCount = (value: any, fallback = 0) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
      };

      const verifiedLands = toArray(ecoTokens?.trustee);
      const boughtLands = toArray(ecoTokens?.boughtBy);
      const mintedLands = toArray(ecoTokens?.mintedBy);

      setBalanceLoading(true);
      try {
        const rawTreeBalance = wallet?.treeBalance ?? walletDetails?.treeBalance ?? source?.treeBalance ?? "0";
        const readableBalance = Number(fromWei(String(rawTreeBalance ?? "0"), "ether"));
        const formattedBalance = formatValue(sixDigits(readableBalance), true);
        setTreeBalance(formattedBalance);
      } catch (balanceError) {
        console.log("tree balance fallback", { balanceError });
        setTreeBalance(0);
      } finally {
        setBalanceLoading(false);
      }

      if (wallet?.createdAt || walletDetails?.createdAt) {
        setJoinedDate(wallet?.createdAt || walletDetails?.createdAt);
      }

      if (wallet) {
        let resolvedProfile = wallet;
        const matchedSecondary = toArray(wallet?.organization?.secondaryWallets).find(
          (secondaryWallet: any) =>
            String(secondaryWallet?.address || "").toLowerCase() === String(address || "").toLowerCase()
        );

        if (matchedSecondary) {
          resolvedProfile = { ...wallet, ...matchedSecondary };
          console.log({ matchedSecondary });
        }

        setProfileData(resolvedProfile);
        console.log(resolvedProfile?.role);

        const resolvedRoleRaw = resolvedProfile?.role ?? wallet?.role ?? walletDetails?.role ?? source?.role ?? "";
        const resolvedRole = String(resolvedRoleRaw).toLowerCase();

        // A "user" who has minted is a Guardian whose backend promotion (GuardianAdded) hasn't
        // landed yet. One who redeemed a guardian invite code but hasn't minted is a Pioneer —
        // same predicate as useAuthorization's isPioneer. Display-only; not a backend role.
        const isPioneerProfile =
          resolvedProfile?.referrerAddress != null &&
          resolvedProfile?.trustStatus === null &&
          resolvedProfile?.trusteeStatus === null &&
          resolvedProfile?.trustAdminStatus === null;
        if (resolvedRole === "user" && mintedLands.length > 0) {
          setRole("guardian");
        } else if (resolvedRole === "user" && isPioneerProfile) {
          setRole("pioneer");
        } else {
          setRole(resolvedRole || "user");
        }
      } else {
        const fallbackRole = String(walletDetails?.role ?? source?.role ?? "").toLowerCase();
        if (fallbackRole) {
          setRole(fallbackRole);
        }
      }

      setHeaderLoading(false);

      // Combine all lands for sorting (to get highest ecoScore for background image)
      const allLands = [...verifiedLands, ...boughtLands, ...mintedLands];

      // `source.trustDismissal.flagsCount` is deliberately not read — see the chainFlags comment.
      // Chain flag standing — best-effort, read-only, never blocks the page.
      try {
        const admin = getReadOnlyContract("ecofutures-admin");
        const challenge = getReadOnlyContract("challenge");
        if (admin && challenge) {
          const [adminCount, adjudicationCount, flagsToDismiss, flaggedOut] = await Promise.all([
            admin.flagCountOf(address),
            challenge.flagsInWindow(address),
            challenge.FLAGS_TO_DISMISS(),
            challenge.isFlaggedOut(address),
          ]);
          setChainFlags({
            adminCount: Number(adminCount),
            adjudicationCount: Number(adjudicationCount),
            flagsToDismiss: Number(flagsToDismiss),
            flaggedOut: Boolean(flaggedOut),
          });
        }
      } catch (chainError) {
        console.warn("[UserWallet] chain flag read failed; using the REST count", chainError);
        setChainFlags(null);
      }

      const resolvedRoleForBg = String(wallet?.role ?? walletDetails?.role ?? source?.role ?? "").toLowerCase();
      if (resolvedRoleForBg !== "admin" && allLands.length > 0) {
        const sortedLands = allLands.sort((a: any, b: any) => (b?.ecoScore || 0) - (a?.ecoScore || 0));
        setLatestLandImage(sortedLands[0]?.content);
      }

      // Map organization data
      if (wallet?.organization) {
        setOrgData(wallet.organization);
      }

      const roleForStats = String(wallet?.role ?? walletDetails?.role ?? source?.role ?? "").toLowerCase();

      // Map lands scanned (verified lands count)
      if (roleForStats === "trust") {
        setLandsScanned(verifiedLands.length);
      } else {
        setLandsScanned(mintedLands.length);
      }

      // Map bought lands count
      setLandsBought(boughtLands.length);

      // Map portfolio value from portfolio sum
      if (wallet?.portfolio?.portfolioSum !== undefined) {
        setPortfolioValue(Number(wallet.portfolio.portfolioSum));
        console.log("Portfolio value set to:", portfolioValue);
      }

      // Map transactions count
      // if (txList && Array.isArray(txList)) {
      //   setTransactions(txList.length);
      // }

      const txCount = toCount(
        walletDetails?.transactions,
        toCount(wallet?.transactions, toArray(source?.transactions).length)
      );
      setTransactions(txCount);
      // Map trustee verifications (org lands) from ecoTokens.trustee
      if (verifiedLands.length > 0) {
        setOrgLands(verifiedLands);
      }

      // Map admin verified trusts if present
      setAdminVerifiedTrusts(toArray(walletDetails?.adminVerifiedTrusts));

      setStatsLoading(false);

      /* OLD API CALLS - REPLACED BY UNIFIED ENDPOINT
      // Fetch basic wallet info first for header
      const wallet: WalletInfoResponse = await axios
        .get(ApiRoutes.user.wallet + `?address=${address}`)
        .then((res) => res.data);
      console.log("wallet", { wallet });

      // Fetch remaining data in parallel for stats and tables
      const [verifiedLands, boughtLands, mintedLands, flags] = await Promise.all([
        axios.get(ApiRoutes.token.trustee(address as string)).then((res) => res.data),
        axios.get(ApiRoutes.token.list + `?boughtBy=${address}`).then((res) => res.data),
        axios.get(ApiRoutes.token.minted(address as string)).then((res) => res.data),
        axios.get(ApiRoutes.trust.getFlags(address as string)).then((res) => res.data),
      ]);

      setFlagCount(flags.flagCount || 0);
      if (wallet.guardingTokens) {
        setLandsScanned(wallet.guardingTokens);
      }
      if (wallet.boughtLands) {
        setLandsBought(wallet.boughtLands);
      }
      if (wallet.boughtLandsValue) {
        setPortfolioValue(wallet.boughtLandsValue);
      }
      if (wallet.transactions) {
        setTransactions(wallet.transactions);
      }
      if (wallet?.trusteeVerifications) {
        setOrgLands(wallet.trusteeVerifications);
      }
      */
    } catch (e) {
      console.log("error", { e });
      setTreeBalance(0);
    } finally {
      setBalanceLoading(false);
      setHeaderLoading(false);
      setStatsLoading(false);
    }
  };

  const flagTrust = async () => {
    setFlagLoading(true);
    setFlagErrorMessage("");
    try {
      // Gasless lane (holder pays no BNB): one EIP-712 signature → backend /relay →
      // resolved only once VerifierFlagged is observed on-chain.
      await relayContractCall(
        "ecofutures-admin",
        "flagVerifierForDismissal",
        [address, flagReason],
        "VerifierFlagged",
        "Flag trustee for dismissal"
      );
      setFlagTrustSuccess(true);
      setFlagReason("");
      setFlagReasonPopupOpen(false);
      setFlagModalOpen(true);
    } catch (error: any) {
      if (isUserRejection(error)) {
        return; // user cancelled the signature — keep the reason popup open
      }
      setFlagErrorMessage(error?.reason || error?.message || "Failed to flag trustee.");
      setFlagTrustSuccess(false);
      setFlagReasonPopupOpen(false);
      setFlagModalOpen(true);
    } finally {
      setFlagLoading(false);
    }
  };

  const handleImagePreviewOpen = (imageSrc: string) => {
    setPreviewImageSrc(imageSrc);
    setImagePreviewOpen(true);
  };

  const handleImagePreviewClose = () => {
    setImagePreviewOpen(false);
    setPreviewImageSrc("");
  };

  return (
    <ScanMain style={{ width: "100%", height: "100%", backgroundColor: "#ccc" }}>
      {headerLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <WidgetContainer style={{ gridTemplateColumns: "1fr" }}>
            <UserWidget
              sx={{
                position: "relative",
                backgroundColor: "#000",
                backgroundImage: latestLandImage
                  ? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),url(${latestLandImage || ""})`
                  : "none",
                objectFit: "cover",
                color: "white",
                borderRadius: "20px",
                border: "none",
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: { xs: "230px", md: "244px" },
              }}
            >
              {isTrust && user.address !== address && role === "trust" && (
                <Box
                  onClick={() => !atDismissalBar && setFlagReasonPopupOpen(true)}
                  sx={{
                    display: { xs: "flex", md: "none" },
                    position: "absolute",
                    top: 20,
                    right: 20,
                    cursor: atDismissalBar ? "not-allowed" : "pointer",
                    opacity: atDismissalBar ? 0.4 : 1,
                    "&:hover": { opacity: atDismissalBar ? 0.4 : 0.7 },
                    zIndex: 2,
                  }}
                >
                  <AnnouncementOutlined sx={{ color: "white", fontSize: 20 }} />
                </Box>
              )}

              <MainWidgetContainer
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  alignItems: { xs: "flex-start", md: "flex-start" },
                  height: "100%",
                  width: { xs: "100%", md: "auto" },
                  gap: 2,
                  zIndex: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: "14px", md: "18px" },
                    width: "100%",
                    alignItems: { xs: "flex-start", md: "flex-start" },
                  }}
                >
                  <Text
                    sx={{
                      fontSize: { xs: "14px", md: "26px" },
                      lineHeight: 1.2,
                      textTransform: "capitalize",
                      fontWeight: { xs: "900", md: "700" },
                    }}
                  >
                    {role === "trust"
                      ? "Trustee"
                      : role === "guardian"
                      ? "Guardian"
                      : role === "pioneer"
                      ? "Pioneer"
                      : isGlobalAdmin
                      ? "Global Trust Admin"
                      : role === "admin"
                      ? "Trust Admin"
                      : "Patron"}
                    {joinedDate && ` since ${moment(joinedDate).format("MMM YYYY")}`}
                  </Text>

                  {role === "trust" && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: 1,
                        cursor: "pointer",
                        opacity: 0.9,
                        "&:hover": { opacity: 1 },
                      }}
                      onClick={() => setOrgModalOpen(true)}
                    >
                      <Text bold sx={{ fontSize: "14px" }}>
                        Organization:
                      </Text>
                      <Text underline bold sx={{ fontSize: "14px" }}>
                        {orgData?.name || "Loading..."}
                      </Text>
                    </Box>
                  )}

                  <Box
                    sx={{
                      display: { xs: "flex", md: "none" },
                      flexDirection: "row",
                      gap: "14px",
                      mt: "12px",
                      mb: "24px",
                    }}
                  >
                    {profileData?.profilePicture && (
                      <Box
                        sx={{
                          width: 60,
                          height: 60,
                          borderRadius: "50%",
                          overflow: "hidden",
                          border: "1px solid rgba(255,255,255,0.2)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "rgba(0,0,0,0.2)",
                          "& img": {
                            width: "100% !important",
                            height: "100% !important",
                            objectFit: role === "admin" ? "cover" : "cover",
                            scale: role === "admin" ? 1 : 1,
                            borderRadius: role === "admin" ? "50%" : "50%",
                          },
                        }}
                      >
                        <ProfilePicture user={profileData} />
                      </Box>
                    )}
                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {role === "trust" ? (
                        <TrusteeIcon sx={{ fontSize: "60px", color: "#BC92F8" }} />
                      ) : role === "guardian" ? (
                        <GuardianIcon sx={{ fontSize: "60px", color: "#BC92F8" }} />
                      ) : role === "pioneer" ? (
                        <PioneerIcon sx={{ fontSize: "60px", color: "#BC92F8" }} />
                      ) : isGlobalAdmin ? (
                        <GlobalTrustAdminIcon sx={{ fontSize: "60px", color: "#BC92F8" }} />
                      ) : role === "admin" ? (
                        <TrustAdminIcon sx={{ fontSize: "60px", color: "#BC92F8" }} />
                      ) : (
                        <PatronIcon sx={{ fontSize: "60px", color: "#BC92F8" }} />
                      )}
                    </Box>
                  </Box>

                  <AddressLink
                    sx={{
                      display: { xs: "none", md: "flex" },
                      fontSize: "14px",
                      color: "black",
                      backgroundColor: "rgba(255, 255, 255, 0.5)",
                      padding: "16px 24px",
                      borderRadius: "20px",
                      width: "fit-content",
                      "a.plainAddress": {
                        color: "black",
                        fontSize: { xs: "14px", md: "14px" },
                        fontWeight: "700",
                      },
                    }}
                    address={address || ""}
                    type="plain"
                    copy
                    long
                  />

                  <AddressLink
                    sx={{
                      display: { xs: "flex", md: "none" },
                      fontSize: "14px",
                      color: "black",
                      backgroundColor: "rgba(255, 255, 255, 0.5)",
                      padding: "12px 16px",
                      borderRadius: "20px",
                      width: "100%",
                      justifyContent: "space-between",
                      "a.plainAddress": {
                        color: "black",
                        fontSize: { xs: "14px", md: "14px" },
                        fontWeight: "700",
                      },
                    }}
                    address={address || ""}
                    type="plain"
                    copy
                  />
                </Box>

                {isTrust && user.address !== address && role === "trust" && (
                  <Box sx={{ mt: "auto", display: { xs: "none", md: "block" } }}>
                    <Box
                      onClick={() => !atDismissalBar && setFlagReasonPopupOpen(true)}
                      sx={{
                        display: "inline",
                        cursor: atDismissalBar ? "not-allowed" : "pointer",
                        opacity: atDismissalBar ? 0.4 : 1,
                        "&:hover": { opacity: atDismissalBar ? 0.4 : 0.8 },
                      }}
                    >
                      <Text bold underline sx={{ color: "white", fontSize: "14px" }}>
                        Report wallet
                      </Text>
                    </Box>
                  </Box>
                )}
              </MainWidgetContainer>

              <MainWidgetContainer
                sx={{
                  display: { xs: "none", md: "flex" },
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: 4,
                  width: "auto",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: { xs: 2, md: 4 },
                  }}
                >
                  {profileData?.profilePicture && (
                    <Box
                      sx={{
                        width: { xs: 80, md: 180 },
                        height: { xs: 80, md: 180 },
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: "2px solid rgba(255,255,255,0.2)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "rgba(0,0,0,0.2)",
                        "& img": {
                          width: "100% !important",
                          height: "100% !important",
                          objectFit: role === "admin" ? "cover" : "cover",
                          scale: role === "admin" ? 1 : 1,
                          borderRadius: role === "admin" ? "50%" : "50%",
                        },
                      }}
                    >
                      <button
                        onClick={() => handleImagePreviewOpen(profileData?.profilePicture)}
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          width: "100%",
                          height: "100%",
                          objectFit: role === "admin" ? "contain" : "cover",
                          scale: role === "admin" ? 0.85 : 1,
                          minWidth: "100%",
                          maxWidth: "100%",
                        }}
                      >
                        <ProfilePicture user={profileData} />
                      </button>
                    </Box>
                  )}

                  <Box
                    sx={{
                      width: { xs: 80, md: 180 },
                      height: { xs: 80, md: 180 },
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {role === "trust" ? (
                      <TrusteeIcon sx={{ fontSize: { xs: "80px", md: "180px" }, color: "#BC92F8" }} />
                    ) : role === "guardian" ? (
                      <GuardianIcon sx={{ fontSize: { xs: "80px", md: "180px" }, color: "#BC92F8" }} />
                    ) : role === "pioneer" ? (
                      <PioneerIcon sx={{ fontSize: { xs: "80px", md: "180px" }, color: "#BC92F8" }} />
                    ) : isGlobalAdmin ? (
                      <GlobalTrustAdminIcon sx={{ fontSize: { xs: "80px", md: "180px" }, color: "#BC92F8" }} />
                    ) : role === "admin" ? (
                      <TrustAdminIcon sx={{ fontSize: { xs: "80px", md: "180px" }, color: "#BC92F8" }} />
                    ) : (
                      <PatronIcon sx={{ fontSize: { xs: "80px", md: "180px" }, color: "#BC92F8" }} />
                    )}
                  </Box>
                </Box>
              </MainWidgetContainer>
            </UserWidget>
          </WidgetContainer>
          {role === "trust" ? (
            <WidgetContainer sx={{ backgroundColor: "#ccc" }}>
              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  backgroundColor: "#BC92F8",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  COUNTRY
                </WidgetRow>
                <WidgetRow sx={{ color: "black !important" }}>
                  {statsLoading ? (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      Loading...
                    </Text>
                  ) : (
                    <Text medium bold numeric sx={{ color: "black !important" }}>
                      {orgData?.country || "Loading..."}
                    </Text>
                  )}
                </WidgetRow>
              </Widget>

              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  backgroundColor: "#CCFF99",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  LANDS VERIFIED
                </WidgetRow>
                <ClickableContainer
                  onClick={() => landsScanned > 0 && setActiveTab("lands")}
                  sx={{ cursor: landsScanned > 0 ? "pointer" : "default" }}
                >
                  <WidgetRow sx={{ color: "black !important" }}>
                    {statsLoading ? (
                      <Text medium numeric bold sx={{ color: "black !important" }}>
                        Loading...
                      </Text>
                    ) : (
                      <Text medium numeric bold sx={{ color: "black !important" }}>
                        {profileData?.portfolio?.totalVerifiedLandsCount}
                      </Text>
                    )}
                  </WidgetRow>
                </ClickableContainer>
              </Widget>

              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  gap: "18px",
                  backgroundColor: "#53593C",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  {isMobile ? "VALUE" : "PORTFOLIO VALUE"}
                </WidgetRow>
                <WidgetRow sx={{ color: "black !important" }}>
                  {statsLoading ? (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      Loading...
                    </Text>
                  ) : (
                    <Text medium numeric bold sx={{ wordBreak: "break-all", color: "black !important" }}>
                      ${toReadable(profileData?.portfolio?.portfolioSum)}
                    </Text>
                  )}
                </WidgetRow>
              </Widget>

              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  backgroundColor: "#959A80",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  {isMobile ? "TX" : "TRANSACTIONS"}
                </WidgetRow>
                <WidgetRow sx={{ color: "black !important" }}>
                  {statsLoading ? (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      Loading...
                    </Text>
                  ) : (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      {transactions}
                    </Text>
                  )}
                </WidgetRow>
              </Widget>
            </WidgetContainer>
          ) : role === "admin" ? (
            <WidgetContainer sx={{ backgroundColor: "#ccc" }}>
              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  backgroundColor: "#BC92F8",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  COUNTRY
                </WidgetRow>
                <WidgetRow sx={{ color: "black !important" }}>
                  {statsLoading ? (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      Loading...
                    </Text>
                  ) : (
                    <Text medium bold numeric sx={{ color: "black !important" }}>
                      {!profileData?.country && Number(profileData?.countryCode) === 0
                        ? "Global"
                        : profileData?.country}
                    </Text>
                  )}
                </WidgetRow>
              </Widget>

              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  backgroundColor: "#CCFF99",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  TRUSTS VERIFIED
                </WidgetRow>
                <WidgetRow sx={{ color: "black !important" }}>
                  {statsLoading ? (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      Loading...
                    </Text>
                  ) : (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      {adminVerifiedTrusts.length || 0}
                    </Text>
                  )}
                </WidgetRow>
              </Widget>

              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  gap: "18px",
                  backgroundColor: "#53593C",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  RECENT
                </WidgetRow>
                <WidgetRow sx={{ color: "black !important" }}>
                  {statsLoading ? (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      Loading...
                    </Text>
                  ) : (
                    <ClickableContainer>
                      <AddressLink
                        sx={{
                          color: "black !important",
                          "& a": {
                            color: "black !important",
                            fontWeight: 700,
                            textDecoration: "none",
                          },
                          "& a:hover": {
                            color: "#333 !important",
                            textDecoration: "none",
                          },
                          "& a.userAddress, & a.trustAddress": { textDecoration: "none" },
                          "& a.userAddress:hover, & a.trustAddress:hover": { textDecoration: "none" },
                        }}
                        address={adminVerifiedTrusts[0]}
                        small
                        type={"user"}
                      />
                    </ClickableContainer>
                  )}
                </WidgetRow>
              </Widget>

              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  backgroundColor: "#959A80",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  {isMobile ? "TX" : "TRANSACTIONS"}
                </WidgetRow>
                <WidgetRow sx={{ color: "black !important" }}>
                  {statsLoading ? (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      Loading...
                    </Text>
                  ) : (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      {transactions}
                    </Text>
                  )}
                </WidgetRow>
              </Widget>
            </WidgetContainer>
          ) : (
            <WidgetContainer sx={{ backgroundColor: "#ccc" }}>
              <Widget
                sx={{
                  borderLeft: 0,
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  backgroundColor: "#BC92F8",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  TR3
                </WidgetRow>
                <WidgetRow sx={{ color: "black !important" }}>
                  {balanceLoading ? (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      Loading...
                    </Text>
                  ) : (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      {treeBalance}
                      {/* <CurrencyLabel sx={{ color: "black" }} /> */}
                    </Text>
                  )}
                </WidgetRow>
              </Widget>

              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  backgroundColor: "#CCFF99",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  PORTFOLIO
                </WidgetRow>
                <ClickableContainer
                  onClick={() => landsBought > 0 && setActiveTab("portfolio")}
                  sx={{ cursor: landsBought > 0 ? "pointer" : "default" }}
                >
                  <WidgetRow sx={{ color: "black !important" }}>
                    {statsLoading ? (
                      <Text medium numeric bold sx={{ color: "black !important" }}>
                        Loading...
                      </Text>
                    ) : (
                      <Text medium numeric bold sx={{ color: "black !important" }}>
                        {landsBought}
                      </Text>
                    )}
                  </WidgetRow>
                </ClickableContainer>
              </Widget>

              <Widget
                sx={{
                  height: "100%",
                  justifyContent: "start",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  border: "none",
                  backgroundColor: "#53593C",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  ASSETS
                </WidgetRow>
                <ClickableContainer
                  onClick={() => landsScanned > 0 && setActiveTab("lands")}
                  sx={{ cursor: landsScanned > 0 ? "pointer" : "default" }}
                >
                  <WidgetRow sx={{ color: "black !important" }}>
                    {statsLoading ? (
                      <Text medium numeric bold sx={{ color: "black !important" }}>
                        Loading...
                      </Text>
                    ) : (
                      <Text medium numeric bold sx={{ color: "black !important" }}>
                        {landsScanned}
                      </Text>
                    )}
                  </WidgetRow>
                </ClickableContainer>
              </Widget>

              <Widget
                sx={{
                  border: "none",
                  flexDirection: { xs: "row", md: "row" },
                  borderRadius: { xs: "20px", md: "20px" },
                  backgroundColor: "#959A80",
                }}
              >
                <WidgetRow
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: 700,
                    fontFamily: "monospace",
                    color: "black !important",
                  }}
                >
                  {isMobile ? "TX" : "TRANSACTIONS"}
                </WidgetRow>
                <WidgetRow sx={{ color: "black !important" }}>
                  {statsLoading ? (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      Loading...
                    </Text>
                  ) : (
                    <Text medium numeric bold sx={{ color: "black !important" }}>
                      {transactions}
                    </Text>
                  )}
                </WidgetRow>
              </Widget>
            </WidgetContainer>
          )}
          <TableWithTabs sx={{ backgroundColor: "back.table", borderRadius: "20px" }}>
            <TabsRow sx={{ p: sizing(6), borderRadius: "20px 20px 0px 0px" }}>
              <FilterBlock
                sx={{
                  "@media (min-width: 600px)": {
                    display: "flex",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    paddingTop: "10px",
                  },
                  "@media (max-width: 599px)": {
                    flexDirection: "row",
                    paddingTop: "10px",
                  },
                }}
              >
                <ActionBtn
                  className={activeTab === "transactions" ? "active" : ""}
                  variant={activeTab === "transactions" ? "contained" : "outlined"}
                  size="medium"
                  onClick={() => setActiveTab("transactions")}
                >
                  Transactions
                </ActionBtn>
                {!!landsBought && role != "trust" && role !== "admin" && (
                  <ActionBtn
                    className={activeTab === "portfolio" ? "active" : ""}
                    variant={activeTab === "portfolio" ? "contained" : "outlined"}
                    size="medium"
                    onClick={() => setActiveTab("portfolio")}
                  >
                    Portfolio
                  </ActionBtn>
                )}
                {role === "admin" && adminVerifiedTrusts.length > 0 && (
                  <ActionBtn
                    className={activeTab === "portfolio" ? "active" : ""}
                    variant={activeTab === "portfolio" ? "contained" : "outlined"}
                    size="medium"
                    onClick={() => setActiveTab("portfolio")}
                  >
                    Verified
                  </ActionBtn>
                )}
                {!!landsScanned && (
                  <ActionBtn
                    className={activeTab === "lands" ? "active" : ""}
                    variant={activeTab === "lands" ? "contained" : "outlined"}
                    size="medium"
                    onClick={() => setActiveTab("lands")}
                  >
                    {role === "trust" ? "Verified" : "Assets"}
                  </ActionBtn>
                )}
              </FilterBlock>
            </TabsRow>

            {activeTab === "lands" && (
              <Grid container sx={{ width: "100%" }}>
                <TableComponent
                  mobileTitle={role === "trust" ? "Verified Lands" : "Assets"}
                  batch={5}
                  totalItems={landsScanned}
                  title={role === "trust" ? "Verified Lands" : "Assets"}
                  hideTitle
                  apiURL={
                    role === "trust"
                      ? ApiRoutes.token.trustee(address as string)
                      : ApiRoutes.token.minted(address as string)
                  }
                  schema={
                    role === "trust"
                      ? isMobile
                        ? MobileEcoBankLandsSchema
                        : TrusteeLandsSchema
                      : isMobile
                      ? MobileEcoBankLandsSchema
                      : EcoBankLandsSchema
                  }
                />
              </Grid>
            )}

            {activeTab === "portfolio" && role !== "admin" && (
              <Grid container sx={{ width: "100%" }}>
                <TableComponent
                  mobileTitle="Portfolio"
                  batch={5}
                  totalItems={landsBought}
                  title="Portfolio"
                  hideTitle
                  apiURL={ApiRoutes.token.list + `?boughtBy=${address}`}
                  schema={isMobile ? MobileEcoBankLandsSchema : EcoBankAssetsSchema}
                />
              </Grid>
            )}

            {role === "admin" && adminVerifiedTrusts.length > 0 && activeTab === "portfolio" && (
              <Grid container sx={{ width: "100%" }}>
                <TableComponent
                  mobileTitle="Portfolio"
                  batch={5}
                  hideTitle
                  totalItems={verifiedByData.length}
                  title="Portfolio"
                  customData={verifiedByData}
                  apiURL=""
                  schema={trusteeSchema
                    .filter((col) => col.id !== "actions")
                    .map((col) =>
                      col.id === "name" && col.label === "Name"
                        ? {
                            ...col,
                            render: (data: any, index?: number) => (
                              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
                                {col.render?.(data, index)}
                                {data?.role && (
                                  <Text
                                    mono
                                    sx={{
                                      fontFamily: "monospace",
                                      textTransform: "uppercase",
                                      fontSize: "16px",
                                      color: "#565656",
                                    }}
                                  >
                                    {data.role}
                                  </Text>
                                )}
                              </Box>
                            ),
                          }
                        : col
                    )}
                />
              </Grid>
            )}

            {activeTab === "transactions" && (
              <Grid container sx={{ width: "100%" }}>
                <TableComponent
                  mobileTitle=""
                  batch={5}
                  totalItems={transactions}
                  hideTitle
                  title=""
                  apiURL={ApiRoutes.ecoBank.transactions.root + `?address=${address}&type=user&addToDetails=true`}
                  schema={isMobile ? TransactionMobileSchema : TransactionsSchema}
                />
              </Grid>
            )}
          </TableWithTabs>

          {/* Org details */}
          <OrgPopUp open={orgModalOpen} onClose={() => setOrgModalOpen(false)} orgData={orgData} orgLands={orgLands} />
          {/* )} */}

          {/* Image Preview Modal */}
          <MuiDialog
            open={imagePreviewOpen}
            onClose={handleImagePreviewClose}
            onClick={handleImagePreviewClose}
            maxWidth="md"
            PaperProps={{
              style: {
                backgroundColor: "transparent",
                boxShadow: "none",
                overflow: "visible",
                border: "none",
              },
            }}
          >
            <DialogContent
              style={{
                padding: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "transparent",
              }}
              onClick={handleImagePreviewClose}
            >
              <img
                src={previewImageSrc}
                alt="Trustee Profile Preview"
                style={{
                  width: isMobile ? "280px" : "400px",
                  height: isMobile ? "280px" : "400px",
                  objectFit: "cover",
                  borderRadius: "50%",
                  maxWidth: isMobile ? "280px" : "400px",
                  maxHeight: isMobile ? "280px" : "400px",
                }}
              />
            </DialogContent>
          </MuiDialog>

          <Modal
            open={flagModalOpen}
            onClose={() => setFlagModalOpen(false)}
            aria-labelledby="land-upload-modal-title"
            aria-describedby="land-upload-modal-description"
            sx={{ width: "100%" }}
          >
            <Wrapper
              sx={{
                width: "100%",
                maxWidth: { xs: "315px", md: "600px" },
                // maxHeight: { xs: '315px', md: '200px' },
                minWidth: { xs: "315px", md: "600px" },
                p: { xs: "20px", md: "45px" },
                backgroundColor: "white",
                marginTop: { xs: "50px", md: "0px" },
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                borderRadius: "20px",
              }}
            >
              <IconContainer
                sx={{
                  top: { xs: "-20px", md: "-40px" },
                  left: { xs: "0%", md: "50%" },
                  width: { xs: "64px", md: "84px" },
                  padding: { xs: "12px", md: "16px" },
                  transform: { xs: "translateX(0%)", md: "translateX(-50%)" },
                }}
              >
                <CircularIcon sx={{ width: { xs: "40px", md: "52px" }, height: { xs: "40px", md: "52px" } }}>
                  <InfoIconOutlined sx={{ fontSize: { xs: "20px", md: "44px" } }} color="primary" />
                </CircularIcon>
              </IconContainer>
              <InfoBody
                sx={{
                  width: "100%",
                  marginTop: { xs: "12px", md: "0px" },
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center",
                  padding: { xs: "20px", md: "0px" },
                }}
              >
                <p
                  style={{
                    fontWeight: 700,
                    color: "black",
                    fontSize: "26px",
                    textAlign: "center",
                    marginBottom: "0px",
                  }}
                >
                  {flagTrustSuccess
                    ? "Trustee was successfully flagged!"
                    : flagErrorMessage
                    ? "Oops..."
                    : "Flag Trustee?"}
                </p>
                <p style={{ fontWeight: 400, color: "black", fontSize: "16px", textAlign: "center" }}>
                  {flagErrorMessage
                    ? flagErrorMessage
                    : ` After ${flagsToDismiss} flags, the Trustee may be dismissed by a Trust Admin that did not admit them.` +
                      (chainFlags
                        ? ` Standing now: ${chainFlags.adminCount} of ${flagsToDismiss} toward dismissal, ${chainFlags.adjudicationCount} panel finding${
                            chainFlags.adjudicationCount === 1 ? "" : "s"
                          } in the last 24 months.`
                        : "")}
                </p>

                <Row
                  sx={{
                    flexDirection: { xs: "column", md: "row" },
                    width: "100%",
                    marginBottom: "auto",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ActionBtn
                    onClick={() => {
                      setFlagModalOpen(false);
                      setFlagTrustSuccess(false);
                      setFlagErrorMessage("");
                      setFlagReason("");
                    }}
                    sx={{
                      padding: "12px 48px",
                      width: { xs: "100%", md: "145px" },
                      height: ButtonHeight,
                      margin: 0,
                      alignSelf: "center",
                      borderRadius: "20px",
                      backgroundColor: "black",
                      ":disabled": {
                        backgroundColor: "black",
                        cursor: "not-allowed",
                        color: "white",
                      },
                    }}
                    variant="contained"
                  >
                    Close
                  </ActionBtn>
                </Row>
              </InfoBody>
            </Wrapper>
          </Modal>
          <Modal
            open={flagReasonPopupOpen}
            onClose={() => {
              setFlagReasonPopupOpen(false);
              setFlagReason("");
            }}
            sx={{ width: "100%" }}
          >
            <Wrapper
              sx={{
                width: "100%",
                maxWidth: { xs: "315px", md: "600px" },
                // maxHeight: { xs: '315px', md: '200px' },
                minWidth: { xs: "315px", md: "600px" },
                p: { xs: "30px 20px 20px 20px", md: "50px" },
                backgroundColor: "white",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                borderRadius: "20px",
              }}
            >
              <IconContainer>
                <CircularIcon>
                  {flagLoading ? (
                    <CircularProgress size={32} color="inherit" sx={{ position: "absolute" }} />
                  ) : (
                    <InfoIconOutlined sx={{ fontSize: { xs: "44px", md: "44px" } }} color="primary" />
                  )}
                </CircularIcon>
              </IconContainer>
              <InfoBody
                sx={{
                  width: "100%",
                  marginTop: { xs: "0px", md: "0px" },
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center",
                  padding: { xs: "20px", md: "0px" },
                }}
              >
                <p
                  style={{
                    fontWeight: 700,
                    color: "black",
                    fontSize: "26px",
                    textAlign: "center",
                    marginBottom: "0px",
                    marginTop: "0px",
                  }}
                >
                  Flag Trustee?
                </p>
                <p style={{ fontWeight: 400, color: "black", fontSize: "16px", textAlign: "center" }}>
                  After {flagsToDismiss} flags, the Trustee may be dismissed by a Trust Admin that did not admit them.
                  {chainFlags
                    ? ` Standing now: ${chainFlags.adminCount} of ${flagsToDismiss} toward dismissal, ${
                        chainFlags.adjudicationCount
                      } panel finding${chainFlags.adjudicationCount === 1 ? "" : "s"} in the last 24 months.`
                    : ""}
                </p>

                <Box sx={{ width: "100%", mb: 3, mt: 2 }}>
                  <textarea
                    value={flagReason}
                    onChange={(e) => setFlagReason(e.target.value)}
                    placeholder="Please provide a reason for flagging this trustee..."
                    style={{
                      width: "100%",
                      minHeight: "120px",
                      padding: "12px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontFamily: "inherit",
                      resize: "vertical",
                      boxSizing: "border-box",
                    }}
                  />
                </Box>

                <Row
                  sx={{
                    flexDirection: { xs: "column-reverse", md: "row" },
                    width: "100%",
                    marginBottom: "auto",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <ActionBtn
                    onClick={() => {
                      setFlagReasonPopupOpen(false);
                      setFlagReason("");
                    }}
                    sx={{
                      padding: "12px 48px",
                      width: { xs: "100%", md: "145px" },
                      height: ButtonHeight,
                      margin: 0,
                      alignSelf: "center",
                      borderRadius: "20px",
                      color: "white",
                      border: "none",
                      backgroundColor: "#ccc",
                      ":hover": {
                        backgroundColor: "#ccc",
                        color: "white",
                        border: "none",
                      },
                      ":disabled": {
                        backgroundColor: "black",
                        cursor: "not-allowed",
                        color: "white",
                      },
                    }}
                    variant="contained"
                  >
                    Close
                  </ActionBtn>
                  <ActionBtn
                    onClick={() => {
                      flagTrust();
                    }}
                    sx={{
                      padding: "12px 48px",
                      width: { xs: "100%", md: "145px" },
                      height: ButtonHeight,
                      margin: 0,
                      alignSelf: "center",
                      borderRadius: "20px",
                      backgroundColor: "black",
                      ":disabled": {
                        backgroundColor: "black",
                        cursor: "not-allowed",
                        color: "white",
                      },
                    }}
                    variant="contained"
                    disabled={flagReason === ""}
                  >
                    Flag
                  </ActionBtn>
                </Row>
              </InfoBody>
            </Wrapper>
          </Modal>
        </>
      )}
    </ScanMain>
  );
};

export const TableWithTabs = styled("div")``;

export default UserWallet;
